import React from 'react'

import { Heading } from '../Typography'
import { FC } from '../../types/common'

const H2: FC = (props) => <Heading tag="h2" {...props} />

export default H2
